import { render, staticRenderFns } from "./DepositRecordList.vue?vue&type=template&id=87ad75b2&"
import script from "./DepositRecordList.vue?vue&type=script&lang=js&"
export * from "./DepositRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports